import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

type SetAfterExportSlot = (node: React.ReactNode) => void;

const HeaderToolbarContext = createContext<{
  afterExportSlot: React.ReactNode;
  setAfterExportSlot: SetAfterExportSlot;
} | null>(null);

export const HeaderToolbarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [afterExportSlot, setAfterExportSlotState] =
    useState<React.ReactNode>(null);

  const setAfterExportSlot = useCallback((node: React.ReactNode) => {
    setAfterExportSlotState(node);
  }, []);

  const value = useMemo(
    () => ({ afterExportSlot, setAfterExportSlot }),
    [afterExportSlot, setAfterExportSlot],
  );

  return (
    <HeaderToolbarContext.Provider value={value}>
      {children}
    </HeaderToolbarContext.Provider>
  );
};

export function useHeaderToolbarAfterExport() {
  const ctx = useContext(HeaderToolbarContext);
  if (!ctx) {
    throw new Error(
      "useHeaderToolbarAfterExport must be used within HeaderToolbarProvider",
    );
  }
  return ctx;
}

/** Header reads this; returns null when provider is absent (e.g. tests). */
export function useHeaderAfterExportSlot(): React.ReactNode {
  return useContext(HeaderToolbarContext)?.afterExportSlot ?? null;
}
